import { CACHE_TTL, STALE_TIMES, CACHE_WARMING_INTERVAL } from '../cache/cacheConfig';

// Configurazione cache per compro oro consigliati - USA COSTANTI CENTRALIZZATE
export const RECOMMENDED_DEALERS_CACHE_CONFIG = {
  // TTL allineati con sistema centrale
  TTL: CACHE_TTL.CLIENT_DEALERS,           // 15 minuti (da centrale)
  PREFETCH_TTL: CACHE_WARMING_INTERVAL,    // 30 minuti (allineato con warming)
  LOCALSTORAGE_TTL: CACHE_TTL.SSR_HIGH,    // 2 ore (persistente tra sessioni)
  SERVER_CACHE_TTL: CACHE_TTL.CLIENT_DEALERS, // 15 minuti
  
  // Chiavi cache
  CACHE_KEYS: {
    MEMORY: 'recommended-dealers-memory',
    LOCALSTORAGE: 'recommended-dealers-storage',
    PREFETCH: 'recommended-dealers-prefetch',
    SERVER: 'recommended-dealers-server'
  },
  
  // Versione cache per invalidazione
  CACHE_VERSION: '2.0',
  
  // Configurazione stale-while-revalidate - CORRETTO: STALE_TIME < MAX_AGE
  STALE_WHILE_REVALIDATE: {
    ENABLED: true,
    STALE_TIME: 7.5 * 60 * 1000,           // 7.5 minuti (50% di MAX_AGE per SWR efficace)
    MAX_AGE: CACHE_TTL.CLIENT_DEALERS      // 15 minuti
  },
  
  // Configurazione cache warming
  CACHE_WARMING: {
    ENABLED: true,
    METALS: ['ORO', 'ARGENTO'],
    PRELOAD_ON_INIT: true
  },
  
  // Configurazione retry per fallback
  RETRY_CONFIG: {
    MAX_RETRIES: 3,
    RETRY_DELAY: 1000, // 1 secondo
    EXPONENTIAL_BACKOFF: true
  }
};

// Utility per generare chiavi cache specifiche
export const generateCacheKey = (metal: string, coordinates?: { lat: number; lng: number }): string => {
  const baseKey = `${RECOMMENDED_DEALERS_CACHE_CONFIG.CACHE_KEYS.MEMORY}-${metal}`;
  
  if (coordinates) {
    // Arrotonda le coordinate per migliorare hit rate della cache
    const lat = Math.round(coordinates.lat * 100) / 100;
    const lng = Math.round(coordinates.lng * 100) / 100;
    return `${baseKey}-${lat}-${lng}`;
  }
  
  return baseKey;
};

// Utility per verificare se i dati sono stale
export const isStale = (timestamp: number): boolean => {
  const now = Date.now();
  return (now - timestamp) > RECOMMENDED_DEALERS_CACHE_CONFIG.STALE_WHILE_REVALIDATE.STALE_TIME;
};

// Utility per verificare se i dati sono scaduti
export const isExpired = (timestamp: number): boolean => {
  const now = Date.now();
  return (now - timestamp) > RECOMMENDED_DEALERS_CACHE_CONFIG.STALE_WHILE_REVALIDATE.MAX_AGE;
};
